import * as React from "react";
import { SVGProps } from "react";
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg width={25} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m24.194 22.575-6.047-6.047a.556.556 0 0 0-.399-.164h-.483a9.707 9.707 0 0 0 2.593-6.614A9.749 9.749 0 0 0 10.108 0a9.749 9.749 0 0 0-9.75 9.75 9.749 9.749 0 0 0 16.364 7.163v.478c0 .15.06.29.164.398l6.047 6.047c.22.22.576.22.797 0l.464-.464a.563.563 0 0 0 0-.797ZM10.108 18a8.244 8.244 0 0 1-8.25-8.25c0-4.56 3.689-8.25 8.25-8.25 4.56 0 8.25 3.69 8.25 8.25 0 4.56-3.69 8.25-8.25 8.25Z"
      fill="#fff"
    />
  </svg>
);
export default SvgSearch;
